module.exports = __webpack_public_path__ + "static/media/mail-icon.9bb5cc8d.svg";